import { Autocomplete, TextField, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IEnseignantItem, IParentStudentItem, setCurrentEtab, setEnseignants } from "../../store/focusEcoleSlice";


export interface ISearchBarByEtabProps {
  localDatasFiltered: IEnseignantItem[];
  setLocalDatasFiltered: (x: IEnseignantItem[]) => void;
  
}

const SearchBarByEtab = (props: ISearchBarByEtabProps) => {

  const { localDatasFiltered, setLocalDatasFiltered } = props

  const dispatch = useDispatch();
  const { currentEtab, enseignants, etabsAppelNote } = useSelector((state: IReduxState) => state.focusEcole);
  console.log("🚀 ~ SearchBarByEtab ~ etabsAppelNote:", etabsAppelNote)
  console.log("🚀 ~ SearchBarByEtab ~ currentEtab:", currentEtab)

  return (
    <Box>
      <Autocomplete
        fullWidth
        onChange={(e: any, etab: any) => {
          if (etab) {
            dispatch(setCurrentEtab({
              ...currentEtab,
              codeEtab: etab.codeEtab
            }));
          }
          else {
            dispatch(setCurrentEtab({}))
            dispatch(setEnseignants([...enseignants]))
            setLocalDatasFiltered([...localDatasFiltered])
          }
        }}
        options={etabsAppelNote}
        renderOption={(props, etab) => {
          const { libelleEtab , codeEtab } = etab;
          const newIndex = etabsAppelNote.findIndex((item: any) => item.codeEtab  === codeEtab )
          return (
            <span {...props}
              style={{ backgroundColor: (newIndex % 2 === 0) ? "aliceblue" : "", fontSize: 13 }}
            >
              {libelleEtab}
            </span>
          );
        }}

        getOptionLabel={(etab) =>
          `${etab.libelleEtab}`
        }

        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            size="small"
            label="Choisir un établissement"
          />
        )}
      />
    </Box>
  );
};
export default SearchBarByEtab;
